import React from 'react'
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import EventIBlogmages_1 from '../img/blog/1.jpg';
import EventBlogImages_2 from '../img/blog/2.jpg';
import EventBlogImages_3 from '../img/blog/3.jpg';
import EventBlogImages_4 from '../img/blog/4.jpg';
import EventBlogImages_5 from '../img/blog/5.jpg';
import EventBlogImages_6 from '../img/blog/6.jpg';
import EventBlogImages_7 from '../img/blog/7.jpg';
import EventBlogImages_8 from '../img/blog/8.jpg';
import EventBlogImages_9 from '../img/blog/9.jpg';


export const EventsinBlog = () => {
    return (
        <div>
            {/*<!-- Events Section -->*/}
            <section className="events-page-section spad">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventIBlogmages_1} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Yoga for Slim Physique</Link></h2>
                                    <p>Regular practice with breathing tech-niques in Yoga will help you get a toned body, this is the perfect choice</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_2} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">The Perfect Dose</Link></h2>
                                    <p>To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_3} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Flexible Body</Link></h2>
                                    <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis prae-sentium voluptatum deleniti</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_4} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">The Secret to Improving</Link></h2>
                                    <p>Regular practice with breathing tech-niques in Yoga will help you get a toned body, this is the perfect choice</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_5} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Movements for Slim</Link></h2>
                                    <p>To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_6} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Update Training Trend</Link></h2>
                                    <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis prae-sentium voluptatum deleniti</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_7} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Have a Toned Body</Link></h2>
                                    <p>Regular practice with breathing tech-niques in Yoga will help you get a toned body, this is the perfect choice</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_8} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Rapid Weight Loss</Link></h2>
                                    <p>To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="blog-item">
                                <img src={EventBlogImages_9} alt="" />
                                <div className="bi-text">
                                    <h2><Link to="/SingleBlog">Healthy Eating Mode</Link></h2>
                                    <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis prae-sentium voluptatum deleniti</p>
                                </div>
                                <div className="bi-footer">
                                    <div className="bi-cata">Health & Beauty</div>
                                    <div className="bi-social">
                                        <Link><FaFacebook /></Link>
                                        <Link><FaInstagram /></Link>
                                        <Link><FaTwitter /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="site-pagination pt-3">
                        <Link className="active">1</Link>
                        <Link>2</Link>
                        <Link><i className="material-icons">keyboard_arrow_right</i></Link>
                    </div>
                </div>
            </section>
            {/*<!-- Events Section end -->*/}

        </div>
    )
}
